/** @format */

import React, { FunctionComponent } from 'react';
import { LocalField } from './LocalProps';
import GridContainer from '../../../components/Grid/GridContainer';
import { Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridItem from '../../../components/Grid/GridItem';
import { PlkField } from '../../../modules/plkFunctions/PlkTypesInterface';

interface LocalRequestViewInterface {
    counter: number;
    parameters: Array<LocalField>;
}

export const LocalRequestView: FunctionComponent<LocalRequestViewInterface> = ({ parameters, counter }) => {
    return (
        <GridContainer>
            <GridItem xs={12}>
                <Typography variant="subtitle2">
                    {counter + ' : '}
                    <I18n trans="prov:vb.request_parameter" />
                </Typography>
            </GridItem>
            {parameters.map((i: PlkField) => {
                if (!Array.isArray(i.value)) {
                    return (
                        <React.Fragment key={i.value + i.key}>
                            <GridItem xs={6}>
                                <b>
                                    <I18n trans={i.key} />
                                </b>
                            </GridItem>
                            <GridItem xs={6}>{i.value}</GridItem>
                        </React.Fragment>
                    );
                } else {
                    i.value.map((v) => {
                        return (
                            <React.Fragment key={v + i.key}>
                                <GridItem xs={6}>
                                    <b>
                                        <I18n trans={i.key} />
                                    </b>
                                </GridItem>
                                <GridItem xs={6}>{v}</GridItem>
                            </React.Fragment>
                        );
                    });
                }
            })}
        </GridContainer>
    );
};
